var map = {
	"./cat-empty-ahorros-white.svg": "4bb9",
	"./cat-empty-ahorros.svg": "f8fb",
	"./cat-empty-alimentacion.svg": "bf02",
	"./cat-empty-blank-document.svg": "802e",
	"./cat-empty-donaciones.svg": "24ba",
	"./cat-empty-educacion.svg": "6473",
	"./cat-empty-hogar.svg": "307e",
	"./cat-empty-ingresos-white.svg": "8438",
	"./cat-empty-ingresos.svg": "5a42",
	"./cat-empty-ocio.svg": "2cdd",
	"./cat-empty-pagodeuda.svg": "07d2",
	"./cat-empty-personales.svg": "430c",
	"./cat-empty-salud.svg": "5c6a",
	"./cat-empty-servicios.svg": "641f",
	"./cat-empty-transporte.svg": "ae0d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "510d";